import {
  IconClock,
  IconDollarBlue,
  IconFavoriteAlt,
} from "app/components/Icon/Icon";
import { EventHelper } from "app/helpers/eventHelper";
import { SportsNameType } from "app/utils/const";
import isPublicView from "app/utils/publicViewUtils";
import React from "react";
import { connect } from "react-redux";
import "./PopularEventCellIcons.scss";

const PopularEventCellIcons = (
  props: Record<string, any>
): React.JSX.Element => {
  const {
    data,
    isEventInExtraTime,
    scoreFullTime,
    toggleAddRemoveToFavorites,
    isBeforeExtraTime,
    isFavourite,
  } = props;

  const handleFavoriteIconClick = (
    event: React.MouseEvent<HTMLSpanElement>
  ) => {
    // Stop event propagation to the parent div
    event.stopPropagation();
    toggleAddRemoveToFavorites();
  };

  return (
    <div className="popular-event-cell__icons-left">
      {EventHelper.isEventGoingLive(data) && (
        <span>
          <IconClock className="icon-desktop--inactive " />
        </span>
      )}
      {isPublicView() ? (
        <span className={`help-widget__bookmark`}>
          <span id="QA__event__favourite-icon" className={"public-view"}>
            <IconFavoriteAlt
              className={`icon--${isFavourite ? "active" : ""}`}
            />
          </span>
        </span>
      ) : (
        <span id="QA__event__favourite-icon" onClick={handleFavoriteIconClick}>
          <IconFavoriteAlt className={`icon--${isFavourite ? "active" : ""}`} />
        </span>
      )}
      {data.hasBetsOnEvent && data.sportType === SportsNameType.SOCCER && (
        <span
          id="QA__event__position-matrix-icon"
          onClick={e => {
            onClickPositionMatrix(props, data);
          }}
        >
          <IconDollarBlue className="icon-desktop--inactive" />
        </span>
      )}
      {isEventInExtraTime ? scoreFullTime : ""}
      {isBeforeExtraTime ? scoreFullTime : ""}
    </div>
  );
};

const onClickPositionMatrix = (props: Record<string, any>, event: any) => {
  const {
    setPositionMatrixModalEvent,
    setPositionMatrixModalItem,
    openPositionMatrixModal,
  } = props;
  setPositionMatrixModalEvent(event);
  setPositionMatrixModalItem(event.id);
  openPositionMatrixModal();
};

const mapDispatchToProps = dispatch => ({
  setPositionMatrixModalEvent: event => {
    dispatch.positionMatrixListModel.setPositionMatrixModalEvent(event);
  },
  setPositionMatrixModalItem: (eventId: number) => {
    dispatch.positionMatrixListModel.setPositionMatrixModalItem({
      eventId: eventId,
    });
  },
  openPositionMatrixModal: () => {
    dispatch.positionMatrixListModel.openPositionMatrixModal();
  },
});

export default connect(null, mapDispatchToProps)(PopularEventCellIcons) as any;
